export default __webpack_public_path__ + "media/b6bfc9d1e4d8489c76a6d6393aa5737ef0861699f5ce8f805ef10055ba789e95.svg";